module.exports = __webpack_public_path__ + "static/media/backtotop.f97a86c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/icons/backtotop.svg
// module id = 206
// module chunks = 0